export default class Api {
  static async getCart () {
    const shopUrl = document.querySelector('meta[name="shop-url"]').content
    const response = await fetch(`${shopUrl}/cart.js`)
    const body = await response.json()
    return body
  }

  static async updateInCart (item, quantity, toRemove, qtyToRemove) {
    const shopUrl = document.querySelector('meta[name="shop-url"]').content
    let payload = {
      updates: {
        [item?.variant_id || item?.shopify_variant_id]: quantity
      }
    }
    if (toRemove) payload = { updates: { ...payload.updates, [toRemove.variant_id || toRemove.shopify_variant_id]: qtyToRemove } }
    await fetch(`${shopUrl}/cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
  }

  static async getAvailableVariants () {
    const joonechargeUrl = document.querySelector('meta[name="joone-charge-url"]').content
    /* global Shopify */
    const response = await fetch(`${joonechargeUrl}/api/products_cart_incentive?shop=${Shopify.shop}`)
    const body = await response.json()
    return body
  }
}
